import React from 'react';
import { Chip } from '@mui/material';

const SEVERITY_STYLES = {
  EXTREME: { bgcolor: 'rgba(183,28,28,0.2)', color: '#ef9a9a', border: '1px solid rgba(183,28,28,0.5)' },
  HIGH:    { bgcolor: 'rgba(230,81,0,0.2)',  color: '#ffb74d', border: '1px solid rgba(230,81,0,0.5)'  },
  MODERATE:{ bgcolor: 'rgba(245,127,23,0.2)',color: '#fff176', border: '1px solid rgba(245,127,23,0.5)'},
  LOW:     { bgcolor: 'rgba(46,125,50,0.2)', color: '#a5d6a7', border: '1px solid rgba(46,125,50,0.5)' },
  UNKNOWN: { bgcolor: 'rgba(84,84,84,0.2)',  color: '#bdbdbd', border: '1px solid rgba(84,84,84,0.5)'  },
};

export default function SeverityChip({ severity, size = 'small' }) {
  const styles = SEVERITY_STYLES[severity] || SEVERITY_STYLES.UNKNOWN;
  return (
    <Chip
      label={severity || 'UNKNOWN'}
      size={size}
      sx={{ fontWeight: 700, fontSize: 11, letterSpacing: 0.5, ...styles }}
    />
  );
}
